module.exports = __webpack_public_path__ + "assets/img/12_139.b5c2f44f.jpg";